/**
 * @flow
 */
import {Dispatch} from 'redux';
import API from '../../services/API'
import {store} from '../store'
import Storage from '../../services/Storage'
import Session from '../../services/Session'
import type {BreadcrumbAction, User, UserAction} from '../../types/types'
import type {SignInAction} from '../reducers/signInReducer';
import type {SignInRequest, SignUpRequest} from '../../types/api-types'
import type {SignUpAction} from '../reducers/signUpReducer'
import {clearSharedData, updateSharedCompanyList} from '../reducers/sharedDataReducers';
import {clearAllSettingsData} from '../reducers/dataReducers';
import {PERM_USER} from '../../types/types';
import Nav from '../../services/Nav';
import {ROUTE} from '../../settings';

export function initUser(dispatch?: Dispatch<UserAction>) {
  const user = Storage.user;
  const token = Storage.token;
  updateUser(dispatch ?? store.dispatch, user, token);
}

export function updateUser(dispatch: Dispatch<UserAction>, user: User, token: string) {
  dispatch({type: 'USER_UPDATE', user, token});
}

export async function signIn(dispatch: Dispatch<SignInAction | UserAction>, request: SignInRequest) {
  const response = await processAPIAction(dispatch, 'signIn', 'SIGN_IN', request);
  if(response) {
    updateUser(dispatch, response.user, response.token);
    Storage.user = response.user;
    Storage.token = response.token;
    Storage.menu = response.menu;
    if(Storage.user.permission !== PERM_USER) {
      // 로그인 직후 컴퍼니 목록을 쿼리함 (어드민 유저인 경우에 한함)
      const res = await API.companyList();
      updateSharedCompanyList(dispatch, res.data);
      Nav.push(ROUTE.DASHBOARD_OVERVIEW);
    } else {
      Nav.push(ROUTE.DASHBOARD_OVERVIEW);
    }
  }
}

export function signOut(dispatch?: Dispatch<SignInAction | UserAction>) {
  //updateUser(dispatch ?? store.dispatch, undefined, undefined);
  clearSharedData(dispatch ?? store.dispatch);
  clearAllSettingsData(dispatch ?? store.dispatch);
  Storage.user = null;
  Storage.token = null;
  Storage.menu = null;
  Session.clear();
  // 페이지를 다시 로드함!
  document.location.href = '/dboard';
}

export async function signUp(dispatch: Dispatch<SignUpAction>, request: SignUpRequest) {
  return processAPIAction(dispatch, 'signUp', 'SIGN_UP', request);
}

export function updateBreadcrumb(dispatch?: Dispatch<BreadcrumbAction>, routeSegments?: {name: string, path?: string}[]) {
  (dispatch ?? store.dispatch)({type: 'BREADCRUMB_UPDATE', routeSegments});
}

async function processAPIAction(dispatch: Dispatch, nameOfAPI: string, prefix: string, data: Object) {
  try {
    dispatch({type: `${prefix}_PENDING`});
    const response = await API[nameOfAPI](data);
    dispatch({type: `${prefix}_DONE`, data, response});
    return response;
  } catch(error) {
    dispatch({type: `${prefix}_ERROR`, data, error});
    throw error;
  }
}
